module.exports = __webpack_public_path__ + "static/media/Item_Weapon_UZI_C.c9d6331b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_UZI_C.png
// module id = ./src/assets/item/Weapon/Main/Item_Weapon_UZI_C.png
// module chunks = 0